// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 531) return "static/chunks/531-0081671d21d7a70b.js";
	if (chunkId === 494) return "static/chunks/494-7f4c8f48a050092f.js";
	if (chunkId === 252) return "static/chunks/252-2f89904f3141a2f6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"0":"2834c5e11db2c004","218":"8e556733ef4aa579","826":"b99271ad6c753ca0"}[chunkId] + ".js";
};